<template>
  <v-tabs v-model="tab" @change="handleOnChangeTab" fluid>
    <v-tab><h2>類別</h2></v-tab>
    <v-tab><h2>品牌</h2></v-tab>
    <v-tab><h2>系列</h2></v-tab>
    <!--  -->
    <v-tab-item v-if="isShowTabContent">
      <AddOne />
    </v-tab-item>
    <v-tab-item v-if="isShowTabContent">
      <AddTwo />
    </v-tab-item>
    <v-tab-item v-if="isShowTabContent">
      <AddThree />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AddOne from './subComponents1/addOne.sc.vue'
import AddTwo from './subComponents1/addTwo.sc.vue'
import AddThree from './subComponents1/addThree.sc.vue'
export default {
  data: () => ({
    tab: sessionStorage.getItem('tab') * 1 || 0,
    isShowTabContent: true
  }),
  components: {
    AddOne,
    AddTwo,
    AddThree
  },
  computed: {
    ...mapState('account', ['uid'])
  },
  methods: {
    ...mapActions('admin', ['getAddOnes', 'getAddTwos']),
    async handleOnChangeTab() {
      sessionStorage.setItem('tab', this.tab)
      // #region Important: run component's created per touch tab
      this.isShowTabContent = false
      this.$nextTick(() => {
        this.isShowTabContent = true
      })
      // #endregion
    }
  },
  created() {
    this.$emit('setTopLabel', 2)
  },
  mounted() {}
}
</script>

<style scoped></style>
